const BUTTON_BASE_CLASS =
    'h-7 px-2.5 rounded-md border text-[12px] font-semibold transition-colors disabled:opacity-50 disabled:cursor-not-allowed inline-flex items-center gap-1.5';
export const NEUTRAL_BUTTON_CLASS = `${BUTTON_BASE_CLASS} border-gray-300 bg-white text-gray-700 hover:bg-gray-50 hover:border-gray-400`;
export const DESTRUCTIVE_BUTTON_CLASS = `${BUTTON_BASE_CLASS} border-red-300 bg-white text-red-600 hover:bg-red-50 hover:border-red-400`;

export function ButtonSpinner() {
    return (
        <span className="h-3 w-3 border-2 border-gray-300 border-t-gray-600 rounded-full animate-spin" />
    );
}
